import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TraductionService {

	private url = 'ws/traduction';

	constructor(private http: HttpClient) {
	}

	/**
	 * Peuple le backend des traductions
	 */
	peupler(): Observable<void> {
		return this.http.put<void>(`${this.url}`, {});
	}

	/**
	 * Exporte à traductions les entités à traduire de l'application
	 */
	exporterTraductions(): Observable<void> {
		return this.http.put<void>(`${this.url}/exporterTraductions`, {});
	}

	/**
	 * Récupère les unités traduites
	 */
	recupererUnites(): Observable<any> {
		return this.http.get<void>(`${this.url}/recupererUnites`);
	}
}
